// client/src/index.js

// 0) Charger et exécuter firebase.js dès le démarrage
import './firebase';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './components/CSS/theme.css';
import './index.css';

// On attend que la persistance soit prête avant de rendre l'app
import { persistenceReady } from './firebase';
import { ensureUserSession } from './utils/ensureUserSession';

// 0-bis) Désactive tout ancien Service Worker / caches hérités
// Ceci évite qu'une version mise en cache par un ancien SW ne serve un UI obsolète
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  const CLEANUP_FLAG = 'ecobill-sw-cleanup-v1';
  const storageCandidates = [
    () => window.localStorage,
    () => window.sessionStorage
  ];

  let flagStore = null;
  let shouldCleanup = true;

  for (const getStore of storageCandidates) {
    try {
      const store = getStore();
      if (store) {
        flagStore = store;
        shouldCleanup = !store.getItem(CLEANUP_FLAG);
        break;
      }
    } catch (e) {
      // ignore and try next candidate
    }
  }

  if (!flagStore) {
    shouldCleanup = !window.__ecobillSwCleanupDone;
  }

  if (shouldCleanup) {
    const tasks = [];

    if (navigator.serviceWorker.getRegistrations) {
      tasks.push(
        navigator.serviceWorker.getRegistrations()
          .then((registrations) => {
            registrations.forEach((registration) => {
              registration.unregister().catch(() => {});
            });
          })
          .catch(() => {})
      );
    }

    if (window.caches?.keys) {
      tasks.push(
        window.caches.keys()
          .then((keys) => Promise.all(keys.map((key) => window.caches.delete(key).catch(() => false))))
          .catch(() => {})
      );
    }

    const finalize = () => {
      try {
        if (flagStore) {
          flagStore.setItem(CLEANUP_FLAG, '1');
        } else {
          window.__ecobillSwCleanupDone = true;
        }
      } catch (e) {
        window.__ecobillSwCleanupDone = true;
      }
    };

    if (tasks.length > 0) {
      Promise.allSettled(tasks).finally(finalize);
    } else {
      finalize();
    }
  }
}

async function bootstrap() {
  try {
    console.log('[index.js] 🔥 démarrage bootstrap');

    // Attendre la restauration de session (locale, puis lien appareil) avant le premier rendu,
    // pour que les routes protégées ne voient jamais un faux « déconnecté ».
    // Aucun compte anonyme n'est créé ici : seuls les flux de scan QR le font.
    await persistenceReady;
    try {
      await ensureUserSession({ allowNewAnonymous: false });
    } catch (e) {
      if (e?.code !== 'no_session' && e?.code !== 'logout_guard') {
        console.warn('[index.js] restauration de session échouée (non bloquant)', e);
      }
    }

    // Monter l’app React
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );

    console.log('[index.js] rendu terminé');
  } catch (err) {
    console.error('[index.js] Erreur au démarrage :', err);
  }
}

// Démarrage
bootstrap();
